module.exports = __webpack_public_path__ + "assets1672972624428/img/unified-avator.51eaf086.png";